import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3" }
const _hoisted_2 = { class: "card h-100" }
const _hoisted_3 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_4 = {
  href: "#",
  class: "text-gray-800 text-hover-primary d-flex flex-column"
}
const _hoisted_5 = { class: "symbol symbol-60px mb-6" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "fs-5 fw-bolder mb-2" }
const _hoisted_8 = { class: "fs-7 fw-bolder mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: `/media/svg/files/${_ctx.fileType}.svg`,
              alt: ""
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.fileTitle), 1),
          _createElementVNode("div", _hoisted_8, " (" + _toDisplayString(_ctx.fileSubtitle) + ") ", 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DownloadFile(_ctx.file)))
        }, _toDisplayString(_ctx.t("download")), 1)
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}